module.exports = __webpack_public_path__ + "img/4.d0b338c1.png";